import styled from 'styled-components';

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
  column-gap: 15px;
`;
